module.exports = __webpack_public_path__ + "img/icon_quote.5a05365.png";